import { render, staticRenderFns } from "./Products.html?vue&type=template&id=8ca83930&scoped=true&external"
import script from "./Products.js?vue&type=script&lang=js&external"
export * from "./Products.js?vue&type=script&lang=js&external"
import style0 from "./Products.vue?vue&type=style&index=0&id=8ca83930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca83930",
  null
  
)

export default component.exports